import ToastedNotification from './scripts/components/toasted-notification.vue';

export default {
  components: {
    ToastedNotification,
  },
};
